import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../../../../userManagement/users/serverApi/types/IUserActionResult';

export interface CreateActiveDirectoryIdentityForUserParams {
  id: string;                // user id or system user id
  identityPoolName: string;  // name of the identity pool that will be used as a login mechanism for this user
  username: string;          // Active directory username
}

export class CreateActiveDirectoryIdentityForSiteUserRequest extends Request<CreateActiveDirectoryIdentityForUserParams, IUserActionResult> {
  constructor(params: CreateActiveDirectoryIdentityForUserParams) {
    super('createActiveDirectoryIdentityforUser', params);
  }
}

export class CreateActiveDirectoryIdentityForServerUserRequest extends Request<CreateActiveDirectoryIdentityForUserParams, IUserActionResult> {
  constructor(params: CreateActiveDirectoryIdentityForUserParams) {
    super('createActiveDirectoryIdentityforServerUser', params);
  }
}
